var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShowEvaluate)?_c('div',{staticClass:"evaluate_box"},[_c('EvaluateListVue',{attrs:{"isShowEvaluateTitle":_vm.isShowEvaluateTitle}})],1):_vm._e(),(_vm.isShowFaq)?_c('div',{staticClass:"faq_box"},[_c('FaqVue')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }